exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-wrap[data-v-2b924c56]{box-sizing:border-box;width:100%;height:200px;overflow:auto;padding:10px;margin:8px 0 4px}.card-wrap[data-v-2b924c56],.dialog-item[data-v-2b924c56]{border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}.dialog-item[data-v-2b924c56]{display:inline-block;margin:0 4px 4px;padding:4px}.card-footer[data-v-2b924c56]{text-align:right;font-size:14px;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2b924c56&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/DebugUser.vue
// module id = 481
// module chunks = 0